"use client";

import React from "react";

const variantStyles = {
  primary:
    "bg-lightYellow text-darkBlack border-lightYellow hover:bg-darkYellow hover:border-darkYellow",
  secondary:
    "bg-lightCyan text-darkBlack border-lightCyan2 hover:bg-strongCyan hover:border-strongCyan2",
  danger: "bg-darkRed text-white border-darkRed hover:bg-darkRed2 hover:border-darkRed2",
  light:
    "bg-white text-darkBlack border-lightGrey3 hover:bg-lightGrey hover:border-darkGrey",
  default:
    "bg-cyanGrey text-darkBlack border-darkGrey hover:bg-darkGrey2 hover:border-darkGrey",
};

const sizeStyles = {
  xs: "min-w-[32px] text-sm py-1 px-2",
  sm: "min-w-[34px] text-[17px] py-1.5 px-3",
  md: "min-w-[75px] min-h-[28px] py-2 px-3",
  lg: "py-2 px-8 font-bold",
};

/**
 * Tailwind-based Button component.
 *
 * @param {string} variant - 'primary' | 'secondary' | 'danger' | 'light' | 'default'
 * @param {string} size - 'sm' | 'md' | 'lg'
 */
export function Button({
  children,
  variant = "default",
  size = "md",
  type = "button",
  disabled = false,
  className = "",
  ...props
}) {
  const baseStyles =
    "inline-flex items-center justify-center font-medium text-base rounded cursor-pointer transition-colors duration-150 border disabled:opacity-50 disabled:cursor-not-allowed";
  const variantClass = variantStyles[variant] ?? variantStyles.default;
  const sizeClass = sizeStyles[size] ?? sizeStyles.md;

  return (
    <button
      type={type}
      disabled={disabled}
      className={`${baseStyles} ${variantClass} ${sizeClass} ${className}`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}
